/**
 * documentextensionreducer.js
 * Created by calhosh on 10/22/2020.
 */
import initialstate from '../initialstate';
import {GET_ALL_DOCUMENT_EXTENSION} from '../../actions/actiontypes';

export default function documentExtensionReducer(state = initialstate.documentExtensions, action) {
	switch (action.type) {
		case GET_ALL_DOCUMENT_EXTENSION:
			if (action.response) {
				return action.response || state;
			}
			break;
		default:
			return state;
	}
}
